import React from 'react';
import { connect } from 'react-redux';
import { routes } from 'constants/config';
import { Icon, Spinner } from 'ui';
import DataProvider from './Partials/DataProvider';
import ReportingBlock from './Partials/ReportingBlock';
import ReportingBlockHeader from './Partials/ReportingBlockHeader';

const AncestorPaths = ({ pathId }) => (
  <DataProvider url={routes.PATH_REPORTING.ANCESTORS(pathId)}>
    {({ data, loading }) => (
      <ReportingBlock className="mh-a">
        <ReportingBlockHeader title="Included in Paths" />
        {loading && <Spinner />}
        {!loading &&
          data.ancestorPaths.map(path => (
            <div className="mt-16" key={path.id}>
              <Icon name="path" className="PerformanceContent-icon" />
              <a className="c-brand-blue fz-bigger" href={routes.PATH(path.id)}>
                {path.title}
              </a>
            </div>
          ))}
      </ReportingBlock>
    )}
  </DataProvider>
);

const mapStateToProps = ({ pathBuilder }) => ({
  pathId: pathBuilder.id,
});

export default connect(mapStateToProps)(AncestorPaths);
